import Vue from 'vue'
import { Notyf } from 'notyf'
import { pluralize, truncate } from '~/lib/utils/format'
import { capitalize, isMobile } from '~/lib/utils/utils'

// design tokens
import $tokens from '~/lib/tokens/tokens.json'

// toast notification
import '~/assets/scss/notyf.scss'

const notyf = new Notyf({
  types: [{
    type: 'error',
    backgroundColor: '#FFFFFF'
  }, {
    type: 'success',
    backgroundColor: '#FFFFFF'
  }],
  duration: 5000,
  position: { x: 'right', y: 'top' }
})

const Clipboard = require('v-clipboard').default
Vue.use(Clipboard)

declare module 'vue/types/vue' {
  interface Vue {
    $tokens: { [key: string]: string },
    $pluralize: typeof pluralize,
    $mixpanelTrack: () => void,
    $capitalize: (string: string) => string,
    $notyf: Notyf,
    $truncate: (text: string, length: number, tail?: string, replaceBR?: boolean) => string,
    $isMobile: typeof isMobile
  }
}
Vue.prototype.$tokens = $tokens
Vue.prototype.$pluralize = pluralize
Vue.prototype.$capitalize = capitalize
Vue.prototype.$notyf = notyf
Vue.prototype.$truncate = truncate
Vue.prototype.$isMobile = isMobile

// v-tooltip
const VTooltip = require('v-tooltip')
Vue.use(VTooltip, {
  defaultClass: 'tooltip'
})

// v click outside
const vClickOutside = require('v-click-outside')
Vue.use(vClickOutside)

// virtual scroll
const VueVirtualScroller = require('vue-virtual-scroller')
Vue.use(VueVirtualScroller)
